/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import {
  IGetCredentialListProps,
  RevokeCredentialProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "AttestCredentialListReviewPageService";
const log: any = LoggerModule.getInstance();

export type IAttestCredentialListReviewPageSrvGetPageContentArgs =
IGetCredentialListProps;

export class AttestCredentialListReviewPageService {
  private static instance: AttestCredentialListReviewPageService;
  private vapp: VApplication;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): AttestCredentialListReviewPageService {
    if (!AttestCredentialListReviewPageService.instance) {
      AttestCredentialListReviewPageService.instance = new AttestCredentialListReviewPageService(
        props
      );
    }
    return AttestCredentialListReviewPageService.instance;
  }

  private setCriteria(data:any){
    this.criteria = data;
  }

  public resetCriteria(){
    this.criteria= null
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  

  public async getPageContent(
    args: IAttestCredentialListReviewPageSrvGetPageContentArgs
  ) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if(args?.criteria){
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getCredentialListsProps({...args, criteria:{...this.criteria, ...args?.criteria}});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async revokeCred(args: RevokeCredentialProps) {
    console.log(`revoke credential id`, args);
    const agent = getAgent();
    return agent.getRevokeCredential(args);
  }

  public async resendCred(args: RevokeCredentialProps) {
    const agent = getAgent();
    return agent.getResendCredential(args);
  }
}
